'use client';

import type { PropsWithChildren } from 'react';

import classnames from 'classnames';

import { ScoreSummary } from '../layout/ScoreSummary';
import type { AssessmentAttemptResultProps } from './AssessmentAttemptResult.types';

import styles from './AssessmentAttemptResult.module.scss';

function AssessmentAttemptResult({
  style,
  className,
  score,
  description,
  elapsedTime,
  answerRate,
  children,
  testId = 'ui-assessment-attempt-result',
}: PropsWithChildren<AssessmentAttemptResultProps>) {
  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          <h3 className={styles['title__description']}>{description}</h3>
        </div>
        <ScoreSummary
          className={styles['score']}
          score={score}
          answerRate={answerRate}
          elapsedTime={elapsedTime}
        />
        <div className={styles['footer']}>{children}</div>
      </div>
    </div>
  );
}

export { AssessmentAttemptResult };
